var __TEMP__ = require('./_copyObject.js');var copyObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getSymbols.js');var getSymbols = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = copySymbols;
